module.exports = __webpack_public_path__ + "img/photo_2023-06-04 10.54.36.020e28cc.jpeg";